var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvieBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5008 1C13.3388 1 15.1016 1.73018 16.4014 3.0299C17.7011 4.32962 18.4313 6.09242 18.4313 7.9305C18.4313 15.6364 21.2422 17.155 22.0015 17.155H1C1.77544 17.155 4.57026 15.6203 4.57026 7.9305C4.57026 6.09242 5.30044 4.32962 6.60016 3.0299C7.89988 1.73018 9.66268 1 11.5008 1V1Z",
    stroke: "#9B2C51",
    strokeWidth: 1.65802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07617 20.1133C9.21582 20.6497 9.52948 21.1246 9.96802 21.4636C10.4065 21.8025 10.9452 21.9864 11.4994 21.9864C12.0537 21.9864 12.5923 21.8025 13.0308 21.4636C13.4694 21.1246 13.783 20.6497 13.9227 20.1133",
    stroke: "#9B2C51",
    strokeWidth: 1.65802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvieBell);
export default __webpack_public_path__ + "static/media/evie-bell.c12b32dfae5f338b2e6502a461563668.svg";
export { ForwardRef as ReactComponent };